import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';

const REFRESH_TOKEN_KEY = 'refreshToken_native';

export async function setNativeRefreshToken(token) {
  try {
    await SecureStoragePlugin.set({ key: REFRESH_TOKEN_KEY, value: token });
    return true;
  } catch (err) {
    console.error('SecureStorage set failed', err);
    return false;
  }
}

export async function getNativeRefreshToken() {
  try {
    const res = await SecureStoragePlugin.get({ key: REFRESH_TOKEN_KEY });
    return res.value || null;
  } catch (err) {
    // Will throw if not found, so return null in that case
    return null;
  }
}

export async function removeNativeRefreshToken() {
  try {
    await SecureStoragePlugin.remove({ key: REFRESH_TOKEN_KEY });
    return true;
  } catch (err) {
    if (err?.includes('does not exist')) {
      return true; // Nothing to remove, treat as success
    }
    console.error('SecureStorage remove failed', err);
    return false;
  }
}

export async function hasNativeRefreshToken() {
  try {
    const keys = await SecureStoragePlugin.keys();
    return keys.keys.includes(REFRESH_TOKEN_KEY);
  } catch {
    return false;
  }
}
